import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as IconoFase1 } from '../../../../assets/svg/Fase1.svg';
import { ReactComponent as IconoFase2 } from '../../../../assets/svg/Fase2.svg';
import { ReactComponent as IconoFase3 } from '../../../../assets/svg/Fase3.svg';
import MobileHeader from '../../Header/MobileHeader/MobileHeader';
import { KpiContext } from '../../../../context/context';

import { MobileSwipeModal } from '../../../../components/mobileSwipeModal/MobileSwipeModal';
import { Grid } from '@mui/material';

import './mobileHomeInterno.scss';

// Kpistemp
const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);
const GET_USER_KPI = gql`
    query QGetKpisUsuario ($idUsuario: Int!) {
        kpisUsuario (idUsuario: $idUsuario)
        {
            success,
            error,
            valorEsperado {
                nombre,
                descripcion,
                valor,
                icono,
                link,
                iframe
            }
        }
    }`;

export const MobileHomeInterno = () => {

  const [kpiContext, setKpiContext] = useContext(KpiContext);
  const [kpiData, setKpiData] = useState([]);

  const { data: dataUserKpi } = useQuery(GET_USER_KPI, {
    variables: { idUsuario: idUsuario }
  });

    useEffect(() => {
        if (!dataUserKpi) return;
        setKpiData(dataUserKpi?.kpisUsuario?.valorEsperado)
    }, [dataUserKpi]);  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
            <MobileHeader />
            <div className='mobile-interno-container'>
                <div className='mobile-interno-banner'>   
                    <div className='mobile-interno-sistema'>
                        <div className='mobile-interno-sistema-titulo'>
                            Soporte Nutricional<br />y Cuidado Domiciliario.<br />
                            Prestaciones modulares<br /> o por prácticas.
                        </div>
                    </div>
                </div>

                <div className='mobile-interno-secciones'>
                    <div className='mobile-interno-seccion'>
                        <div className='mobile-interno-seccion-titulo'>
                            Servicios Nutrihome
                        </div>
                        <a href="https://www.nutrihome.com.ar/wp-content/uploads/2020/05/vademecum_2020.pdf" style={{ padding: '0px' }} color="#2D72B4" underline="none" title="Descargar Vademecum de Servicios Nutrihome" target="_blank">
                            <div className='mobile-interno-seccion-link'>
                                Descargar
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2" />
                                </svg>
                            </div>
                        </a>                                                        
                    </div>
                    <div className='mobile-interno-seccion'>
                        <div className='mobile-interno-seccion-titulo'>
                            Never events
                        </div>
                        <a href="#dv-events" style={{ padding: '0px' }} color="#2D72B4" underline="none" title="Ir a la sección Never events">
                            <div className='mobile-interno-seccion-link'>
                                Leer más                                
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2" />
                                </svg>
                            </div>
                        </a>                 
                    </div>
                    <div className='mobile-interno-seccion'>
                        <div className='mobile-interno-seccion-titulo'>
                            Nutrición enteral
                        </div>
                        {/* <Link href="https://www.nutrihome.com.ar/wp-content/uploads/2020/05/vademecum_2020.pdf" color="#2D72B4" underline="none" title="Descargar Vademecum de Servicios Nutrihome" target="_blank"> */}
                            <div className='mobile-interno-seccion-link'>
                                Próximamente
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2" />
                                </svg>
                            </div>
                        {/* </Link>                 */}
                    </div>                    
                    <div className='mobile-interno-seccion'>
                        <div className='mobile-interno-seccion-titulo'>
                            Nuestros valores
                        </div>
                        <a href="#dv-valores" style={{ padding: '0px' }} color="#2D72B4" underline="none" title="Ir a la sección Nuestros valores">
                            <div className='mobile-interno-seccion-link'>
                                Leer más
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2" />
                                </svg>
                            </div>
                        </a>                
                    </div>
                </div>

                <div className='mobile-interno-modulos'>
                    <div className='mobile-interno-modulos-titulo'>
                        Incorporamos la teleconsulta<br /> en los siguientes módulos:
                    </div>                    
                    <div className='mobile-interno-modulos-grilla'>
                        <div className='mobile-interno-modulos-column img-modulo-1'>
                            <div className='mobile-interno-modulo-texto'>
                                Alimentación parenteral
                            </div>
                        </div>
                        <div className='mobile-interno-modulos-column img-modulo-2'>
                            <div className='mobile-interno-modulo-texto'>
                                Alimentación enteral
                            </div>
                        </div>

                        <div className='mobile-interno-modulos-column img-modulo-3'>
                            <div className='mobile-interno-modulo-texto'>
                                Alimentación oral/cetoanálogos
                            </div>
                        </div>
                    </div>
                </div>

                <div className='mobile-interno-fases'>
                    <div className='mobile-interno-fases-titulo'>
                        Cada módulo tendrá 3 fases:
                    </div>
                    <div className='mobile-interno-fases-grilla'>
                        <div className='mobile-interno-fases-column'>
                            <IconoFase1 />
                            <div className='mobile-interno-fase-numero'>
                                Fase 1
                            </div>
                            <div className='mobile-interno-fase-nombre'>
                                Inicio
                            </div>
                            <div className='mobile-interno-fase-texto'>
                                Adecuación del paciente al tratamiento.
                                Capacitación paciente /familiar.
                                <br />
                                <strong>Duración 3 meses.</strong>
                            </div>
                        </div>
                        <div className='mobile-interno-fases-column'>
                            <IconoFase2 />
                            <div className='mobile-interno-fase-numero'>
                                Fase 2
                            </div>
                            <div className='mobile-interno-fase-nombre'>
                                Mixta
                            </div>
                            <div className='mobile-interno-fase-texto'>
                                Evolución por teleconsulta que alterna visita
                                presencial de seguimiento
                                <br />
                                <strong>Duración 3 meses.</strong>
                            </div>
                        </div>
                        <div className='mobile-interno-fases-column'>
                            <IconoFase3 />
                            <div className='mobile-interno-fase-numero'>
                                Fase 3
                            </div>
                            <div className='mobile-interno-fase-nombre'>
                                Autocuidado
                            </div>
                            <div className='mobile-interno-fase-texto'>
                                Evolución por teleconsulta que alterna visita
                                presencial de seguimiento
                                <br />
                                <strong>Duración 3 meses.</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='mobile-interno-valores-grilla'>
                    <div id="dv-valores" className='mobile-interno-valores-column mobile-interno-celeste'>
                        <div className='mobile-interno-valores-bloque'>
                            <div className='mobile-interno-valores-titulo'>
                                Nuestros valores
                            </div>
                            <div className='mobile-interno-valores-texto'>
                                Nuestros valores forman parte de nuestra cultura corporativa:
                                Enfoque al cliente, Calidad, Integridad, Colaboración, Creatividad, Pasión y Compromiso.
                                <br /><br />
                                El éxito de Nutrihome depende de cada uno de nosotros.
                                <br /><br />
                                Vivir nuestros valores es un requisito previo para diferenciarnos de la competencia y hacer realidad nuestra visión.
                            </div>
                        </div>
                        <div className='mobile-interno-valores-img'></div>
                    </div>
                </div> 
                <div id='dv-events' className='mobile-interno-never'>
                    <div className='mobile-interno-never-titulo'>
                        Never events
                    </div>
                    <div className='mobile-interno-never-texto'>
                        1.- Prestar un servicio sin tener el consentimiento informado firmado.
                        <br /><br />
                        2.- Prestar servicio sin tener la capacitación del paciente o familiar firmada.
                        <br /><br />
                        3.- No tener una historia clínica documentada apropiadamente.
                        <br /><br />
                        4.- Comunicaciones a terceros sin autorización sobre rechazos de pacientes y suspensiones por falta de cobertura o negativa del paciente.
                        <br /><br />
                        5.- Colocar / recolocar una sonda sin hacer control por placa radiográfica o medición de pH.
                        <br /><br />
                        6.- No cumplir con el módulo pactado.
                        <br /><br />
                        7.- Falsificación de un registro.
                        <br /><br />
                        8.- Infundir medicación sin autorización de médico de seguimiento y sin revisar si no es alérgico al mismo.
                    </div>
                </div>
            </div>            

            <MobileSwipeModal
        onClose={() => setKpiContext('none')}
        open={kpiContext === 'block'}
        title={'Metricas'}>
        
                <Grid
          className='kpi-main-section'
          container
          columns={1}
          justifyContent='flex-start'>
          
                    {kpiData?.map((kpi) =>
          <Grid key={kpi.nombre} size={{ xs: 1 }}>
                            <div className='kpi-column'>
                                <span className='kpi-header'>
                                    {kpi.nombre}
                                </span>
                                <div className='kpi-row'>
                                    <span className='kpi-value'>
                                        {kpi.valor}
                                    </span>
                                </div>
                            </div>
                        </Grid>
          )}
                </Grid>
            </MobileSwipeModal>
        </>);

};

export default MobileHomeInterno;